import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQItem[] = [
    {
      question: 'Do you ship across the U.S.?',
      answer: 'Yes! We ship nationwide. All orders are processed and shipped within 1-3 business days. You\'ll receive tracking information once your order ships.'
    },
    {
      question: 'Do you offer local delivery?',
      answer: 'Absolutely. We offer free local delivery on orders over $50 in Kalamazoo and Grand Rapids. Same-day or next-day delivery is available for most orders.'
    },
    {
      question: 'What products do you sell?',
      answer: 'BillPlay offers premium streetwear including clothing, footwear, and accessories. Our collections blend style, comfort, and culture for people of all ages.'
    },
    {
      question: 'How often do new arrivals drop?',
      answer: 'We release new collections and restocks regularly. Sign up for our email list to be first to know about upcoming drops and exclusive releases.'
    },
    {
      question: 'How do I hear about the next release?',
      answer: 'Join our email list at the bottom of this page. We send notifications before every drop so you never miss out on new arrivals and limited releases.'
    },
    {
      question: 'Who do I contact with questions?',
      answer: 'Reach us at billplaycustoms@gmail.com or call 269-993-2813. We\'re here to help with orders, sizing, delivery, and any other questions.'
    },
    {
      question: 'Where is BillPlay Apparel based?',
      answer: 'We\'re proudly based in Kalamazoo, Michigan—specifically the Northside, where the brand was founded in 2017. We serve locally and ship nationwide.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-32 px-8 bg-[#0A0A0A]">
      <div className="max-w-[1000px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 border border-white/20 rounded-full px-5 py-2 mb-8">
            <span className="text-xs font-bold text-white tracking-wide">QUESTIONS</span>
          </div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight mb-8">
            Frequently<br />
            Asked Questions
          </h2>

          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Everything you need to know about BillPlay, shipping, delivery, and more.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-[#181818] border border-[#333333] rounded-2xl overflow-hidden hover:border-white/30 transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="text-lg md:text-xl font-bold text-white pr-8">
                  {faq.question}
                </span>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-white transition-transform duration-300`}></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6 text-base md:text-lg text-gray-300 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-300 mb-6">
            Still have questions? We're here to help.
          </p>
          <a 
            href="mailto:billplaycustoms@gmail.com"
            className="inline-block border border-white text-white px-10 py-4 rounded-lg font-black text-sm hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap"
          >
            EMAIL US
          </a>
        </div>
      </div>
    </section>
  );
}